import { ADVERT_UPGRADE_PLAN } from 'types';
import { create } from 'zustand';

export type ModalType =
    | 'advanced-filter'
    | 'login'
    | 'register'
    | 'advertImages'
    | 'advertRejectNote'
    | 'advertUpgrade'
    | 'increaseBalance'
    | 'advertOtp'
    | 'advertReactivate'
    | 'advertPayment';
interface ModalData {
    rejectNote?: string;
    upgradeData?: {
        advertId: number;
        type: ADVERT_UPGRADE_PLAN;
    };
    createData?: {
        phoneNumber?: string;
        formData: any;
    };
    reactivateData?: {
        advertId: number;
    };
}

export interface ModalStore {
    type: ModalType | null;
    data: ModalData;
    onClose: () => void;
    isOpen: boolean;
    onOpen: (type: ModalType, data?: ModalData) => void;
}

export const useModal = create<ModalStore>((set) => ({
    data: {},
    type: null,
    isOpen: false,
    onOpen: (type, data = {}) => set({ isOpen: true, type, data }),
    onClose: () => set({ isOpen: false, type: null }),
}));
